module.exports = __webpack_public_path__ + "static/img/img-home-top.b63889e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/img-home-top.svg
// module id = JAWW
// module chunks = 1